import PropTypes from 'prop-types';
import React from 'react';
import { isIOS, isAndroid } from 'react-device-detect';
import { openLocationWithPrefix } from '../../utils/routes';

const redirectUrl = (customerId, brandId, userAgent, sendTrackingEvent) => async (url) => {
  if (customerId) {
    await sendTrackingEvent(customerId, brandId, url, userAgent);
  }

  window.location.assign(url);
};

const MobileAppLinkRedirect = ({ location, sendTrackingEvent }) => {
  const customerId = location.query.customerId;
  const brandId = location.query.brandId;
  const androidUrl = location.query.android;
  const iosUrl = location.query.ios;
  const userAgent = navigator.userAgent;

  const redirectUrlWithArgs = redirectUrl(customerId, brandId, userAgent, sendTrackingEvent);

  if (isAndroid && androidUrl) {
    redirectUrlWithArgs(androidUrl);
  } else if (isIOS && iosUrl) {
    redirectUrlWithArgs(iosUrl);
  } else if (iosUrl) {
    redirectUrlWithArgs(iosUrl);
  } else if (androidUrl) {
    redirectUrlWithArgs(androidUrl);
  } else {
    openLocationWithPrefix('/404');
  }

  return (<div className="o-wrapper u-text-center alpha u-mt">Redirecting...</div>);
};

MobileAppLinkRedirect.propTypes = {
  location: PropTypes.object, // eslint-disable-line
  sendTrackingEvent:  PropTypes.func.isRequired, // eslint-disable-line
};
MobileAppLinkRedirect.defaultProps = {};

export default MobileAppLinkRedirect;




// WEBPACK FOOTER //
// ./src/app/mobileApp/components/MobileAppLinkRedirect.jsx